import {
  OnboardingContactServiceMethods,
  OnboardingServices,
} from 'clickNgo/configs/service/onboarding'
import { WebSocketStoreKeys } from 'clickNgo/configs/service/ws'
import { getAccessToken } from 'cng-common/helpers/access'
import WebSocketStore from 'core/classes/services/WebSocketStore'
import { TResponse } from 'core/classes/ws/WebSocketClient'

import { ContactWorkflowStatus, IContact } from '../model/types'

interface ICreateContactResponse {
  contactId: string
  email: string
  entryId375: number
  entryId379: number
  partnerId: string
  workflowStatus: ContactWorkflowStatus
}

type TErrorResponse = Array<{ message: string }>

export const createContact = async (
  contact: Partial<IContact>
): Promise<TResponse<ICreateContactResponse & { error: TErrorResponse }>> => {
  const token = getAccessToken()
  const wsClient = WebSocketStore.get(WebSocketStoreKeys.Onboarding)

  return wsClient.call<ICreateContactResponse & { error: TErrorResponse }>({
    service: OnboardingServices.Contact,
    action: OnboardingContactServiceMethods.Update,
    payload: contact,
    token: token || undefined,
    withoutTokenRefresh: true,
    isAuth: true,
    returnError: true,
  })
}
